import script from "./CustomFieldForCell.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomFieldForCell.vue?vue&type=script&setup=true&lang=js"

import "./CustomFieldForCell.vue?vue&type=style&index=0&id=8372616e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8372616e"]])

export default __exports__